import { initialStrollerDetailState } from "@/mk2/apps/strollers/containers/StrollersDetail/StrollersDetail.reducers";
import { AppState } from "@/mk2/reducers";

export const getStrollersDetailState = (state: AppState, slug: string, variantId?: number) => {
    if (variantId) {
        return (
            state.containers.strollers.strollersDetail[`${slug}-${variantId}`] ||
            initialStrollerDetailState
        );
    } else {
        return state.containers.strollers.strollersDetail[slug] || initialStrollerDetailState;
    }
};
